module.exports = __webpack_public_path__ + "static/media/scripting_api_1.bb0c0451.jpg";